module.exports = __webpack_public_path__ + "img/saba_no.84e69573.png";